import Vue from 'vue'

Vue.filter('currency', function (value: number) {
  return value || value === 0 ? value.toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' }) : '€ -'
})
